import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import {
  DataStateChangeEventArgs,
  GridComponent,
  PageSettingsModel,
} from "@syncfusion/ej2-angular-grids";
import { Observable, Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { viewBtachBO } from "./viewbatch.model";
import { ViewbatchService } from "./viewbatch.service";
import { ClaimsService } from "../claims.service";
import * as pbi from "powerbi-client";
import { DatePipe } from "@angular/common";
import { ConfigurationService } from "src/app/configuration.service";

@Component({
  selector: "app-viewbatch",
  templateUrl: "./viewbatch.component.html",
  styleUrls: ["./viewbatch.component.scss"],
})
export class ViewbatchComponent implements OnInit {
  private onDestroy$: Subject<void> = new Subject<void>();
  @ViewChild("gridViewBatch") public gridViewBatch: GridComponent;
  @ViewChild("reportContainer", { static: false }) reportContainer: ElementRef;
  public ViewBatchData: Observable<DataStateChangeEventArgs>;
  public pageSizes = [10, 15, 20, 50, 100, 250];
  initialPage: PageSettingsModel;
  public filterSettings: object;
  public formatOptions: object;

  viewBatchListBo: viewBtachBO = new viewBtachBO();

  reportContain:boolean=false;
  documentType: string = "";
  configuration: any;
  Token: string = "";
 
  constructor(
    public batchService: ViewbatchService,
    public cliamservice: ClaimsService,
    public datePipe: DatePipe,
    public configurationservice: ConfigurationService,
  ) {
    this.ViewBatchData = this.batchService;
    this.configuration = this.configurationservice.getConfiguration();
  }

  ngOnInit(): void {
    this.filterSettings = { type: "Menu" };
    this.formatOptions = { type: "date", format: "MM/dd/yyyy" };   
    this.initialPage= {pageSize: 10}
    this.getViewBatchList();
  }

  public onActionComplete(G) {
    this.viewBatchListBo.currentpageno =
      this.gridViewBatch.pagerModule.pagerObj.currentPage;
    this.viewBatchListBo.pageitem =
      this.gridViewBatch.pagerModule.pagerObj.pageSize;
    if (G.name == "actionBegin" && G.requestType == "filterbeforeopen") {
      this.viewBatchListBo.type = G.columnType;
    }
  }

  showColumn() {
    this.gridViewBatch.columnChooserModule.openColumnChooser(200, 50);
  }

  getViewBatchList() {
    this.batchService.execute(this.viewBatchListBo);
    this.ViewBatchData.pipe(takeUntil(this.onDestroy$)).subscribe(
      (data: any) => {
      }
    );
  }

  downloadClaimFile(ViewBatchfile) {
    var FileSaver = require("file-saver");
    let blob = new Blob([ViewBatchfile.ediString], {
      type: "text/plain;charset=utf-8",
    });
    FileSaver.saveAs(blob, ViewBatchfile.fileName);
  }

  getclaimID(claimId) {
    let params = new URLSearchParams();
    params.append("edi837Id", claimId);
    this.cliamservice
      .getBatchFileTstring(params)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((data) => {
        this.downloadClaimFile(JSON.parse(data));
      });
  }

  getclaimsID(value) {
      let FILENAME = 'EDI837-'+ value.interchangeControlNumber 
  }
  //----------------------------------------------------------------------------------------------------------------\\
  gettoken() {
    return new Promise((resolve, rejects) => {
      this.batchService
        .getpowerbiToken()
        .pipe(takeUntil(this.onDestroy$))
        .subscribe(
          (data: any) => {
            this.Token = data;
            resolve(data);
          },
          (error: any) => {
            resolve(error.message);
          }
        );
    });
  }

  public dataStateChange(state): void {
    this.documentType = state.action.requestType.toString();

    if (this.documentType != "filterchoicerequest") {
      if ((state.sorted || []).length) {
        this.viewBatchListBo.orderColumn = state.sorted[0].name;
        this.viewBatchListBo.orderType =
          state.sorted[0].direction === "descending" ? "DESC" : "ASC";
      }
    }
    if (
      this.documentType == "filtering" &&
      state.action.action != "clearFilter"
    ) {
      this.viewBatchListBo.field = state.action.currentFilterObject.field;
      this.viewBatchListBo.matchCase =
        state.action.currentFilterObject.matchCase;
      this.viewBatchListBo.operator = state.action.currentFilterObject.operator;
      this.viewBatchListBo.value = state.action.currentFilterObject.value;
    } else {
      if (
        this.documentType == "filtering" &&
        state.action.action == "clearFilter"
      ) {
        this.viewBatchListBo.field = "clearingHouseName";
        this.viewBatchListBo.matchCase = false;
        this.viewBatchListBo.operator = "startswith";
        this.viewBatchListBo.value = "";
        this.viewBatchListBo.type = "string";
      }
    }
    if (this.documentType != "refresh") {
      this.getViewBatchList();
    }
  }

  closemodal(){
    document.getElementById('openReportModal').click();
    this.reportContain = false;
  } 

  showReport(value) {   
    let currentTime = this.datePipe.transform(new Date(), "MM/dd/yyyy hh:mm a");
    let FILENAME = 'EDI837-'+value.interchangeControlNumber 
    this.reportContain = true;
    this.gettoken().then((token) => {
      document.getElementById("openReportModal").click();

      let embedUrl =
        "https://app.powerbi.com/rdlEmbed?reportId=" +
        this.configuration.reportId837 +
              
        "&rp:FileId=" +
        value.id +
        "&rp:FileName=" + FILENAME +
        "&rp:ExecTime=" +
        currentTime +
        "&filterPaneEnabled=False&rdl:parameterPanel=hidden";

      let embedReportId = this.configuration.reportId837;
      let config = {
        type: "report",
        tokenType: pbi.models.TokenType.Aad,
        accessToken: token[0],
        embedUrl: embedUrl,
        id: embedReportId,
        settings: {},
        viewmode: pbi.models.ViewMode.View,
      };
      let reportContainer = this.reportContainer.nativeElement;
      let powerbi = new pbi.service.Service(
        pbi.factories.hpmFactory,
        pbi.factories.wpmpFactory,
        pbi.factories.routerFactory
      );
      let report = powerbi.embed(reportContainer, config);
      report.off("loaded");
      report.on("loaded", () => { });
    });
  }

}
